// dialog-state.service.ts — convert to signal
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DialogStateService {
    private _dialogOpen = signal(false);
    readonly dialogOpen = this._dialogOpen.asReadonly();

    setDialogOpen(open: boolean) {
        this._dialogOpen.set(open);
        if (open) {
            document.body.classList.add('dialog-open');
        } else {
           setTimeout(() => {
               document.body.classList.remove('dialog-open');
           },280);
        }
    }
}
